import React from "react";
import { Controller, useForm } from "react-hook-form";
import ErrorMessage from "../../../../components/text/ErrorMessage";
import { Lead } from "../../../../core/api/models";
import {
    AssignCompanyLead,
} from "../../../../core";
import "react-widgets/dist/css/react-widgets.css";
import api from "../../../../api";
import AddCompany from "../../../company/AddCompany";
import AddUser from "../../../company/AddUser";
import RemoteDataMultiSelectDropDown from "../../../../components/dropdown/RemoteDataMultiSelectDropDown";
import { UserImage } from "../../../../components/user-image";
import { AutoCompleteInput } from "../../../../components/form-group";
import { toastr } from "react-redux-toastr";

const AssignCompany: React.FunctionComponent<{
    lead?: Lead;
    onClose?: () => void;
    onSuccess?: () => void;
    className?: string;
}> = (props) => {
    const {
        control,
        handleSubmit,
        errors,
        watch,
        setValue,
        trigger
    } = useForm<AssignCompanyLead>({
        reValidateMode: "onChange",
        mode: "onSubmit",
    });

    const [isSubmiting, setIsSubmiting] = React.useState<boolean>(false);
    const [addModal, setAddModal] = React.useState<{
        isOpen?: boolean;
        id?: string;
    }>({});
    const [userModal, setUserModal] = React.useState<{
        isOpen?: boolean;
        userId?: string;
    }>({});

    const loadCompanyPeople = async () => {
        const response = await api.customer.getCompanyPeople(watch('company')?._id
            || '');
        return response;
    };

    const onSubmit = async (data: any) => {
        setIsSubmiting(true);
        try {
            await api.lead.assignCompanyToLead(
                data.company._id,
                data.people.map((person:any) => person._id),
                props.lead?.customer?._id || '',
                props.lead?._id || ''
            )

            toastr.success("Success", "Lead assigned to company successfully");
            props.onSuccess?.();
            setIsSubmiting(false);
        } catch (error) {
            setIsSubmiting(false);

            if (error?.response?.data?.message) {
            toastr.error("Error", error?.response?.data?.message);
            }
        }
    };

    const companyCreated = (data: any) => {
        setValue('company', data)
        setAddModal({})
        trigger("company");
    };

    const customerCreated = (data: any) => {
        setValue('people', [data])
        trigger("people");
        setUserModal({userId: data?._id});
    };

    if (!props.lead) {
        return <></>;
    }

    return (
        <div className={`${props.className || ""} pt-2 pb-4`}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="form-group font-weight-semibold mb-3">
                    <label htmlFor="" className="font-sm text-uppercase">
                        Select Company<span className="text-danger">*</span>
                    </label>
                    <Controller
                        control={control}
                        rules={{ required: true }}
                        name="company"
                        render={({ onChange, value, name }) => (
                            <AutoCompleteInput
                                isIconHidden={true}
                                defaultValue={value}
                                customPlaceholder={"Select Company"}
                                onChange={(val) => {
                                    onChange(val);
                                    setValue('people',undefined)

                                }}
                                apiUrl="/api/company/search"
                                valueField={"name"}
                                hideBlocked={true}
                                dataLoader={async (query?:string) => {
                                    const response = await api.company.searchCompanyInline({ query }) as any ;
                                    return [...response?.tenants];
                                  }}
                            />
                        )}
                    />
                    {errors.company && <ErrorMessage>Company is required</ErrorMessage>}
                    <div className="d-flex flex-row-reverse mt-1">
                        <span className="text-primary font-sm" role="button" onClick={() => setAddModal({ isOpen: true })}>Add New Company</span>
                    </div>
                    {addModal.isOpen && (
                        <AddCompany
                            onClose={() => setAddModal({})}
                            onCreateCompanyWithData={companyCreated}
                        />
                    )}
                </div>

                {watch('company') && <div className="form-group font-weight-semibold mb-3">
                    <label htmlFor="" className="font-sm text-uppercase">
                        Select People<span className="text-danger">*</span>
                    </label>
                    <Controller
                        control={control}
                        rules={{
                            required: true,
                            validate: (value) => {
                                return value?.length > 0;
                            },
                        }}
                        name="people"
                        defaultValue={[]}
                        render={({ onChange, value, name }) => (
                            <RemoteDataMultiSelectDropDown
                                key={`${watch('company')?._id}-${userModal.userId}`}
                                loadData={loadCompanyPeople}
                                textField="firstName"
                                value={value}
                                defaultValue={value}
                                valueField="_id"
                                onChange={(val) => {
                                    onChange(val);
                                }}
                                placeholder="Select People"
                                itemComponent={({ item }) => (
                                    <UserImage
                                        user={item}
                                    ></UserImage>
                                )}
                                tagComponent={({ item }) => (
                                    <UserImage
                                        user={item}
                                    ></UserImage>
                                )}
                            />
                        )}
                    />
                    {errors.people && (
                        <ErrorMessage>Company People is required</ErrorMessage>
                    )}
                    <div className="d-flex flex-row-reverse mt-1">
                        <span className="text-primary font-sm" role="button" onClick={() => setUserModal({ isOpen: true })}>Add New People</span>
                    </div>
                </div>}

                <div className="form-group font-weight-semibold mb-3 text-right pt-3 d-flex justify-content-between align-items-center">
                    <div className="text-right">
                        <button
                            onClick={props.onClose}
                            className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4 mr-1"
                            type="button"
                        >
                            Cancel
                        </button>
                        <button
                            disabled={isSubmiting}
                            className="btn btn-primary py-2 font-weight-semibold font-normal px-4 "
                        >
                            Submit
                        </button>
                    </div>
                </div>
            </form>
            {userModal?.isOpen && (
                        <AddUser
                            isCompanyLead={true}
                            onClose={() => setUserModal({})}
                            customerCreatedWithData={customerCreated}
                            companyId={watch('company')?._id}
                            isCompany360
                        />
                    )}
        </div>
    );
};

export default AssignCompany;
